import { createSelector } from 'reselect';
export var selectLegendState = state => state.legend;
var selectAllLegendPayload2DArray = state => selectLegendState(state).payload;
export var selectLegendPayload = createSelector([selectAllLegendPayload2DArray], payloads => payloads.flat(1));